import { Box, Typography } from '@mui/material'
import React from 'react'
import AdjustSharpIcon from '@mui/icons-material/AdjustSharp';
import { InputCompo } from '../../../Components/InputCompo/InputCompo';
import { map } from 'leaflet';




const ProfileSection = ({ user,labelsToDisplay, purpose, interest, updates, type, labelsToDisplay2,UsName, UsEmailId, UsMobileNumber, UsLocation, InThematic, InGeography, InBenificiary, InFCRA, Uptags, uptrue, tyUser, organisation, tyName }) => {
    
    return (
        <div>
            {user &&
                <Box sx={{ padding: "0 0 16px 0", borderBottom: '1px solid #c6c6c8', display: 'flex', flexDirection: 'column' }}>
                    <div className='flex gap-1 items-center'>
                        <AdjustSharpIcon sx={{ fontSize: '15px', color: '#004878' }} />
                        <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex' }}>  User Information</Typography>
                    </div>
                    <div className='w-[100%] flex flex-col gap-2 my-2'>
                        {/* <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>  Account Type :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {UsAccountType}</Typography>
                        </div> */}
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>  Name :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {UsName}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}> Email ID :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {UsEmailId}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Mobile Number :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {UsMobileNumber}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Location:</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {UsLocation}</Typography>
                        </div>
                    </div>
                </Box>
            }
            {purpose &&
                <Box sx={{ padding: "16px 0", borderBottom: '1px solid #c6c6c8', display: 'flex', flexDirection: 'column' }}>
                    <div className='flex gap-1 items-center'>
                        <AdjustSharpIcon sx={{ fontSize: '15px', color: '#004878' }} />
                        <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex' }}>  Purpose, Interests & Notifications</Typography>
                    </div>
                    <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex', margin: '16px 0 0 0' }}>  Purpose, Interests & Notifications</Typography>
                    <ul className='flex flex-col gap-2 list-disc pl-5'>
                        { labelsToDisplay.length > 0 ? (
                                labelsToDisplay.map((label, index) => (
                                <li key={index}>
                                    <Typography variant="subtitle1" sx={{ color: 'black', fontWeight: 500 }}>
                                    {label}
                                    </Typography>
                                </li>
                                ))
                            ) : (
                                <Typography variant="subtitle1" sx={{ color: 'black', fontWeight: 500 }}>
                                    No data available.
                                </Typography>
                            )}
                    </ul>
                </Box>
            }
            {interest &&
                <Box sx={{ padding: "16px 0", borderBottom: '1px solid #c6c6c8', display: 'flex', flexDirection: 'column' }}>
                    <div className='flex gap-1 items-center'>
                        <AdjustSharpIcon sx={{ fontSize: '15px', color: '#004878' }} />
                        <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex' }}>Areas of interest</Typography>
                    </div>
                    <div className='w-[100%] flex flex-col gap-2 my-2'>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Thematic Area :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {InThematic}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Geography :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {InGeography}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Beneficiary Groups :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {InBenificiary}</Typography>
                        </div>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>FCRA :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {InFCRA}</Typography>
                        </div>

                    </div>
                </Box>
            }
            {updates &&
                <Box sx={{ padding: "16px 0", borderBottom: '1px solid #c6c6c8', display: 'flex', flexDirection: 'column' }}>
                    <div className='flex gap-1 items-center'>
                        <AdjustSharpIcon sx={{ fontSize: '15px', color: '#004878' }} />
                        <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex' }}>Updates & Notifications</Typography>
                    </div>
                    <div className='w-[100%] flex flex-col gap-2 my-2'>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' ,flexShrink:'0'}}>Tags :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 , textAlign:'justify'}}> {Uptags}</Typography>
                        </div>
                        <label className="flex items-center space-x-2">
                            <InputCompo
                                className='bg-[#004878] text-white w-[20px] h-[20px]'
                                type='checkbox'
                                checked={uptrue}
                            />
                            <span className='text-black'>Periodic Insights & Updates</span>
                        </label>
                    </div>
                </Box>
            }
            {type &&
                <Box sx={{ padding: "16px 0", borderBottom: '1px solid #c6c6c8', display: 'flex', flexDirection: 'column' }}>
                    <div className='flex gap-1 items-center'>
                        <AdjustSharpIcon sx={{ fontSize: '15px', color: '#004878' }} />
                        <Typography variant='subtitle1' sx={{ color: '#004878', fontWeight: 600, display: 'flex' }}>User Type</Typography>
                    </div>
                    <div className='w-[100%] flex flex-col gap-2 my-2'>
                        <div className='flex w-[100%]'>
                            <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Type of user  :</Typography>
                            <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {tyUser}</Typography>
                        </div>
                    </div>
                    <ul className='flex flex-col gap-2 list-disc pl-5'>
                        {labelsToDisplay2?.map(list => (
                            <>
                                <li>
                                    <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}>{list}</Typography>
                                </li>
                            </>
                        ))}
                    </ul>
                    {tyUser === "Institutional/ Group" &&
                        <div className='w-[100%] flex flex-col gap-2 my-2'>
                            <div className='flex w-[100%]'>
                                <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Name of institution/group : </Typography>
                                <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {tyName}</Typography>
                            </div>
                            <div className='flex w-[100%]'>
                                <Typography variant='subtitle1' sx={{ color: '#696969', fontWeight: 500, width: '200px' }}>Organisation : </Typography>
                                <Typography variant='subtitle1' sx={{ color: 'black', fontWeight: 500 }}> {organisation}</Typography>
                            </div>
                        </div>
                    }
                </Box>
            }
        </div>
    )
}

export default ProfileSection